export default function (props: any[] = []) {
    return function (state, rootProps) {
        if (props.length > 0) {
            const newState: any = {};
            props.map(prop => {
                newState[prop] = state[prop];
            });
            return newState;
        } else {
            return state;
        }

    };
}


// WEBPACK FOOTER //
// ./src/utils/mapStateToProps.tsx